/* @flow */
/* eslint no-unused-vars: 0 */

import React from "react"
import ProductAggregateOption from "./aggregate_option"

class ProductAggregate extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      view_all: false,
      filter_value: '',
      original_options: this.props.agg.options,
      filtered_options: this.props.agg.options
    };

    this.toggleAggregation = this.toggleAggregation.bind(this);
    this.toggleViewAll = this.toggleViewAll.bind(this);
    this.handleFilterValue = this.handleFilterValue.bind(this);
    this.filterOptions = this.filterOptions.bind(this);
    this.resetSearch = this.resetSearch.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState(
      {
        original_options: nextProps.agg.options
      },
      () => {
        this.filterOptions();
      }
    );
  }

  toggleAggregation() {
    this.setState({
      expanded: !this.state.expanded
    });
  }

  toggleViewAll() {
    this.setState({
      view_all: !this.state.view_all
    });
  }

  handleFilterValue(e) {
    this.setState(
      {
        filter_value: e.target.value
      },
      () => {
        this.filterOptions();
      }
    );
  }

  filterOptions() {
    var new_list = this.state.original_options.filter(option => {
      if (option.key !== null) {
        return option.key
          .toUpperCase()
          .includes(this.state.filter_value.toUpperCase()) === true
          ? option
          : false;
      } else {
        return false;
      }
    });

    this.setState({ filtered_options: new_list });
  }

  resetSearch() {
    this.setState({ filter_value: '' }, () => {
      this.filterOptions();
    });
  }

  render() {
    const toggled =
      this.state.expanded === false ? (
        <i className="icon-plus" />
      ) : (
        <i className="icon-minus" />
      );

    let view_all = this.state.filtered_options.length > 11 ? 'View All' : '';

    if (this.state.view_all === true) {
      view_all = 'View Less';
    }

    const search_options =
      this.props.agg.options.length > 11 ? (
        <span className="filter--aggregates">
          <input
            type="text"
            value={this.state.filter_value}
            placeholder={`Search ${
              this.props.agg.title === 'kw rating'
                ? 'kW Rating'
                : this.props.agg.title.replace(/_/g, ' ')
            }`}
            onChange={this.handleFilterValue}
          />
          <button onClick={this.resetSearch}>
            {this.state.filter_value === '' ? (
              <img src={this.props.assets.icons.search_white} alt="" />
            ) : (
              <img src={this.props.assets.icons.cross_white} alt="" />
            )}
          </button>
        </span>
      ) : (
        ''
      );

    const options =
      this.state.filtered_options.length === 0 ? (
        <b>No Options found.</b>
      ) : (
        this.state.filtered_options.map((option, index) => {
          return (
            <ProductAggregateOption
              key={index}
              option={option}
              agg_type={this.props.agg.title}
              assets={this.props.assets}
              toggleAggregate={this.props.toggleAggregate}
            />
          );
        })
      );

    return (
      <li
        className={
          'product--aggregate ' +
          (this.state.expanded === true ? 'expanded' : '')
        }
      >
        <span
          onClick={this.toggleAggregation}
          className={this.props.agg.title === 'kw rating' ? 'no-capital' : ''}
        >
          {this.props.agg.title === 'kw rating'
            ? 'kW Rating'
            : this.props.agg.title.replace(/_/g, ' ')}
          {toggled}
        </span>
        {search_options}
        <ul
          className={
            (this.state.expanded === true ? 'expanded' : '') +
            (this.state.view_all === true ? ' view-all' : '')
          }
        >
          {options}
        </ul>
        <span className="view-all" onClick={this.toggleViewAll}>
          {view_all}
        </span>
      </li>
    );
  }
}

export default ProductAggregate;
